export default __webpack_public_path__ + "static/media/playlist.8eebf29d.svg";